export enum EnumsDomStorage {
  ACTIVE_APPLICATION = 'active-application',
  ACTIVE_UNIT = 'active-unit',
  ACTIVE_UNIT_ID = 'active-unit-id',
  AUTH_TOKEN = 'auth-token',
  IGNORE_SM = 'ignore-sm',
  LANGUAGE = 'language',
  ONBOARDING_VARIANT = 'onboarding_variant',

  ORIGIN_URL_PATH = 'origin_url_path',
  ORIGIN_URL_QUERIES = 'origin_url_queries',
  USERCENTRICS_INTERACTION = 'uc_user_interaction',

  B2B_ACTIVE_COMPANY_ID = 'active_company',
}

export enum DocumentType {
  Picture = 'Picture',
  EmployeeProfilePicture = 'EmployeeProfilePicture',
  Cv = 'CV',
  MotivationLetter = 'MotivationLetter',
  Contract = 'Contract',
  Certificate = 'Certificate',
  CertifiedCertificate = 'CertifiedCopyUEC',
  Other = 'Other',
  CertificateGermanSkills = 'Certificate German skills',
  DeRegistrationCertificate = 'De-registration certificate',
}

/*
 * TODO: Structure error codes similar to backend.
 *       Check ErrorCode class in backend repository.
 */
export enum FrontendErrorCode {
  AUTH_ERROR = 10001,
  NO_UNIT = 10002,
  NO_APPLICATION = 10002,
  FILE_BASE64 = 10003,
  FETCH_ERROR = 10004,
}

export enum EnumsB2bPermissions {
  B2B_PERMISSION_EMPLOYEES_ADD = 'create employees',
  B2B_PERMISSION_EMPLOYEES_EDIT = 'edit employees',
  B2B_PERMISSION_EMPLOYEES_DELETE = 'delete employees',

  B2B_PERMISSION_COMPANY_DATA = 'edit company master data',
  B2B_PERMISSION_COMPANY_PORTRAIT = 'edit company portrait',
  B2B_PERMISSION_COMPANY_PAYMENT = 'edit company payment details',

  B2B_PERMISSION_JOBOPENING_CREATE = 'create job openings',
  B2B_PERMISSION_JOBOPENING_EDIT = 'edit job openings',

  B2B_PERMISSION_CONTRACTS_REQUEST = 'request contracts',
  B2B_PERMISSION_CONTRACTS_EDIT = 'edit contracts',
  B2B_PERMISSION_CONTRACTS_DOWNLOAD = 'view student contracts',
}

export enum DirectionType {
  LEFT,
  RIGHT,
}

export enum EnumsJobOpeningStatusText {
  APPLICANT_WAS_RECOMMENDED = 'applicant was recommended',
  APPLICANT_IS_INTERESTED = 'applicant is interested',
  COMPANY_IS_INTERESTED = 'company is interested',
  COMPANY_HAS_ACCEPTED = 'company has accepted',
  POSITION_EXPIRED = 'job opening expired',
}

export enum MetadataKey {
  // Common
  FEEDBACK_GIVEN = 'feedbackGiven',
  FLOWS = 'flows',

  // B2B
  HIDE_DMS_INFO_MODAL = 'hideDmsInfoModal',
  HIDE_DMS_INFO_MODAL_HOME = 'hideDmsInfoModalHome',
  HIDE_DMS_INFO_MODAL_JOB_OPENINGS = 'hideDmsInfoModalJobOpenings',
  HIDE_PAYMENT_DETAILS_WARNING = 'hidePaymentDetailsWarning',
  HIDE_SUPPORT_TICKET_NOTICE = 'hideSupportTicketNotice',
  HIDE_COURSE_OF_STUDY_INFO = 'hideCourseOfStudyInfo',

  // B2C
  ONBOARDING_DONE = 'onboardingDone',
  INTERACTED_WITH_MOTIVATION_STEP = 'interactedWithMotivationStep',
  VISITED_STUDY_ADVICE_VIEW = 'visitedStudyAdviceView',
  HIDE_B2C_STUDY_MATCH_INTEREST_MODAL = 'hideB2cStudyMatchInterestModal',
  UNLOCKED_STEP2_ALREADY = 'unlockedStep2already',
  UNREAD_JOB_OPENINGS = 'unreadJobOpenings',
  VISITED_SELFMATCHING_VIEW = 'visitedSelfMatchingView',
}

export enum ConsentType {
  USER_RESEARCH = 'user_research',
  AMPLITUDE = 'amplitude',
}

export enum ConsentStatus {
  NOT_ANSWERED = 'not_answered',
  OPT_IN_SINGLE = 'opt_in_single',
  OPT_IN_DOUBLE = 'opt_in_double',
  OPT_OUT = 'opt_out',
}

export enum OnboardingVariant {
  ORIGINAL = 'Original',
  VARIATION_1 = 'Variation 1',
}

export enum AbTastyCampaignIds {
  ONBOARDING_FLOW = import.meta.env.VITE_CAMPAIGN_ID_ONBOARDING_FLOW,
}

export enum ApplicationStatus {
  AWAITING_ANY_INTEREST = 'awaiting_any_interest',
  AWAITING_PARTNER_INTEREST = 'awaiting_partner_interest',
  AWAITING_APPLICANT_INTEREST = 'awaiting_applicant_interest',
  AWAITING_INTERVIEW_SCHEDULE = 'awaiting_interview_schedule',
  INTERVIEW_SCHEDULED = 'interview_scheduled',
  TRIAL_DAY_SCHEDULED = 'trial_day_scheduled',
  AWAITING_PARTNER_CONFIRMATION = 'awaiting_partner_confirmation',
  AWAITING_APPLICANT_CONFIRMATION = 'awaiting_applicant_confirmation',
  OFFER_ACCEPTED = 'offer_accepted',
  CANCELLED = 'cancelled',
}

export enum MatchLostReason {
  STAFFED_WITH_ANOTHER_APPLICANT = 'staffed with another applicant',
  REJECTED_BY_COMPANY = 'rejected by company',
  REJECTED_BY_APPLICANT = 'rejected by applicant',
  JOB_OPENING_HAS_BEEN_CLOSED = 'job opening has been closed',
}

export enum MatchSource {
  COMPANY = 'company',
  APPLICANT = 'applicant',
  STUDY_ADVISOR = 'study_advisor',
}

export enum ViewStatus {
  NEW = 'new',
}

export enum JobOpeningStatus {
  DRAFT = 'draft',
  OPEN = 'open',
  STAFFED = 'staffed',
  CLOSED = 'closed',
}

export enum UniversityEntranceQualificationType {
  UNIVERSITY_ENTRANCE_DIPLOMA_FROM_ABROAD = 'University entrance diploma from abroad',
  HIGH_SCHOOL_DIPLOMA_MATURA = 'Abitur / Matura',
  SUBJECT_SPECIFIC_HIGH_SCHOOL_DIPLOMA = 'fachgebundenes Abitur',
  UNIVERSITY_OF_APPLIED_SCIENCES_ENTRANCE_QUALIFICATION = 'Fachhochschulreife',
  MASTERS_CERTIFICATE = 'Meisterbrief',
  APPRENTICESHIP_WITH_PRACTICAL_EXPERIENCE = 'Apprenticeship with practical experience',
  STATE_CERTIFIED_TECHNICIAN_OR_STATE_CERTIFIED_BUSINESS_ECONOMIST = 'staatlich geprüfte(r) TechnikerIn oder staatlich geprüfte(r) BetriebswirtIn',
}

export enum TrackingEventType {
  // Email Verification Step
  ONBOARDING_EMAIL_VERIFICATION_VIEWED = 'onboarding_emailVerification_viewed',
  ONBOARDING_EMAIL_VERIFICATION_RESENT = 'onboarding_emailVerification_resent',

  // Onboarding Welcome Step
  ONBOARDING_WELCOME_VIEWED = 'onboarding_welcome_viewed',
  ONBOARDING_WELCOME_CLICKED = 'onboarding_welcome_clicked',

  // Onboarding HZB (= University Entrance Qualification Type) Step
  ONBOARDING_HZB_VIEWED = 'onboarding_hzb_viewed',
  ONBOARDING_HZB_SAVED = 'onboarding_hzb_saved',
  ONBOARDING_HZB_BACK_BUTTON_CLICKED = 'onboarding_hzb_backButtonClicked',

  // Onboarding EEB (= Erfolgreiche Erstberatung / Successful Consultation)
  ONBOARDING_EEB_VIEWED = 'onboarding_eeb_viewed',

  // Mainscreen EEB (= Erfolgreiche Erstberatung / Successful Consultation)
  MAIN_SCREEN_EEB_VIEWED = 'mainscreen_eeb_viewed',

  // EEB (= Erfolgreiche Erstberatung / Successful Consultation)
  EEB_STARTED = 'eeb_booking_started',

  // Onboarding Language Step
  ONBOARDING_LANGUAGE_VIEWED = 'onboarding_language_viewed',
  ONBOARDING_LANGUAGE_BACK_BUTTON_CLICKED = 'onboarding_language_backButtonClicked',
  ONBOARDING_LANGUAGE_SAVED = 'onboarding_language_saved',

  // Onboarding Insufficient German Language Skills Step
  ONBOARDING_LANGUAGE_BLOCKED_VIEWED = 'onboarding_languageBlocked_viewed',
  ONBOARDING_LANGUAGE_BLOCKED_CLICKED = 'onboarding_languageBlocked_clicked',

  // Onboarding International Success Step
  ONBOARDING_INTERNATIONAL_SUCCESS_VIEWED = 'onboarding_internationalSuccess_viewed',
  ONBOARDING_INTERNATIONAL_SUCCESS_CLICKED = 'onboarding_internationalSuccess_clicked',

  // Hzb Document Upload Step
  ONBOARDING_HZBUPLOAD_VIEWED = 'onboarding_hzbUpload_viewed',
  ONBOARDING_HZBUPLOAD_UPLOADED = 'onboarding_hzbUpload_uploaded',

  // Lanuage Certificate Upload Step
  ONBOARDING_LANGUAGECERT_UPLOAD_VIEWED = 'onboarding_languageUpload_viewed',
  ONBOARDING_LANGUAGECERT_UPLOADED = 'onboarding_languageUpload_uploaded',

  // Main Screen / DS Home
  MAIN_SCREEN_VIEWED = 'mainscreen_viewed',
}
